import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.number.constructor.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VoidUrl } from "@/common/types";
import { assert } from "@/common/assert";
import { formatImageUrl } from "@/common/utils";
import "./ChatCompanyCardMessageItem.scss";
import { cmsHomeUrl } from "@/urls";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
export default function ChatCompanyCardMessageItem(props) {
  var attr = props.message.customAttrs;
  assert(attr, "Oops, attr is falsy");
  var companyId = parseInt(attr.COMPANY_ID_KEY, 10);
  var companyName = attr.COMPANY_NAME_KEY;
  var companyUrl = cmsHomeUrl(companyId, {
    stat_ctx: "ChatRoom"
  }); // eslint-disable-next-line fht-eslint-rules/string-literal-validator

  var defaultCompanyLogoUrl = "https://img2.fht360.com/82/bf/13da66c4479b957cdf4462ffbac0.png@!origin";
  var logoUrl = formatImageUrl(attr.COMPANY_LOGO_URL_KEY, ImageSizeTypeEnum.Thumbnail100whFill) || defaultCompanyLogoUrl;

  var previewImage = _jsx("a", __assign({
    href: companyUrl,
    target: "_blank",
    className: "company-card-message__logo"
  }, {
    children: _jsx("img", {
      alt: "\u4F01\u4E1Alogo",
      src: logoUrl
    }, void 0)
  }), void 0);

  var joinCompanyLink = null;

  if (!props.myself.companyId) {
    joinCompanyLink = _jsx("a", __assign({
      href: VoidUrl,
      className: "company-card-message__joinCompany",
      onClick: function onClick(e) {
        return props.onJoinCompany({
          CompanyId: Number(companyId),
          Message: ""
        });
      }
    }, {
      children: "\u52A0\u5165\u4F01\u4E1A"
    }), void 0);
  }

  return _jsxs("div", __assign({
    className: "company-card-message"
  }, {
    children: [_jsxs("div", __assign({
      className: "company-card-message__content"
    }, {
      children: [previewImage, _jsx("a", __assign({
        href: companyUrl,
        target: "_blank",
        className: "company-card-message__name",
        title: companyName
      }, {
        children: companyName
      }), void 0)]
    }), void 0), _jsxs("div", __assign({
      className: "company-card-message__btns"
    }, {
      children: [_jsx("a", __assign({
        href: cmsHomeUrl(companyId),
        target: "_blank",
        className: "company-card-message__visitCompany"
      }, {
        children: "\u67E5\u770B\u4F01\u4E1A"
      }), void 0), props.myself.userId && joinCompanyLink]
    }), void 0)]
  }), void 0);
}